export const SET_NEEDREFRESH = "SET_NEEDREFRESH";

export const setNeedRefresh = (needRefresh) => (dispatch) => {
    try {
        return dispatch({ type: SET_NEEDREFRESH, payload: needRefresh });
    } catch (error) {
        console.log("ERREUR SET_NEEDREFRESH ", error);
    }
};